module.exports = __webpack_public_path__ + "static/Light-Red-20f675332d82df89b515c90acbbc9b92.png";